const BASEURL = process.env.REACT_APP_BASE_URL_CAMS;
export const AUTH = {
  login: `${BASEURL}/EcoAuthentication/login`,
  register: `${BASEURL}/EcoAuthentication/register`,
  sendResetLink: `${BASEURL}/EcoAuthentication/get-password-reset-token`,
  resetPassword: `${BASEURL}/EcoAuthentication/reset-forgotten-password`
};
export default BASEURL;
